import { render, staticRenderFns } from "./TokenSessionAuthorizations.vue?vue&type=template&id=6cc5a850"
import script from "./TokenSessionAuthorizations.vue?vue&type=script&lang=js"
export * from "./TokenSessionAuthorizations.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports